// import { isInApp } from '@du/utils'
// import { getQueryString } from '@/utils/index'
// // import { popupOutsideAppPopup } from '../../commonCom/popup'
// // import { goActivity, navigation } from '@/utils/jockey'
// // import { getResultDynamicConfig } from '@/utils/dynamicBanner'
// // import { resolveAppRouterOrWeb } from '@/utils/jockey/util'
import { ItemType } from './interface'
// import throttle from 'lodash/throttle'
// import styles from './index.less'
// import appInstall from '@/utils/appUtils/appInstall'

export const isOdd = (num: number) => {
  return num % 2 === 1
}

// let hasRegister = false
// export const registerJump = (needScene = false, delayp = 600) => {
//   console.log('%cregisterJump', 'color:red')
//   if (hasRegister) {
//     return
//   }
//   hasRegister = true
//   const redirectTo = (e: MouseEvent) => {
//     const target = e.target as HTMLImageElement
//     if (!target.classList.contains(styles.img)) {
//       return
//     }
//     const { key, url } = target.dataset
//     // 点击相应交由父级dom的点击
//     // app内打开
//     if (!isInApp() && !getQueryString('isInApp') && needScene === true) {
//       // popupOutsideAppPopup(!needScene)
//       appInstall(window.location.href)
//       return
//     }
//     // const redirectKey = Number(key)
//     // const redirectValue = url
//     // 自定义类型走统一路由
//     // if (redirectKey === 108) {
//     //   navigation({ url: resolveAppRouterOrWeb(redirectValue).url })
//     // } else {
//     //   // 其他走kv
//     //   goActivity(redirectKey, redirectValue, redirectKey === 5 ? redirectValue : void 0)
//     // }
//   }
//   const jumpHandle = throttle(redirectTo, delayp)

//   document.addEventListener('click', jumpHandle)
// }
/**
 * 返回一个格式化的json
 */
export function formatBannerList(list: ItemType[]) {
  const now = Date.now()
  return list.map((it) => {
    if (it.dynamicConfig) {
      const result = getResultDynamicConfig(it.dynamicConfig, now)
      if (result) {
        return {
          ...it,
          img: result.url,
          redirect: result.redirect,
          spuId: result.spuId,
          materialsID: result.materialsID,
        }
      }
    }
    return it
  })
}

export const SENV = process.env.SENV

export enum rotationTimeEnum {
  oneMinutesMs = 60 * 1000,
  oneHourMs = 60 * oneMinutesMs,
  dayMs = oneHourMs * 24,
}

export const defaultRotationTime = rotationTimeEnum.dayMs

// https://m.poizon.com/router/web/BrowserPage

// TODO 公共方法
const defaultPathConfigEnv = {
  pre: 'https://pre-ffast.poizon.com/poizon/detail/zh-TW/HK',
  pro: 'https://fast.poizon.com/poizon/detail/zh-TW/HK',
}

export function getResultDynamicConfig(config: any, nowTime = Date.now()) {
  const {
    bannerList,
    rotationTime = defaultRotationTime,
    createTime,
    isAutoReplaceImg,
    activityId,
  } = config
  // 自动换图才找是哪个图
  if (!bannerList || !bannerList.length) {
    return
  }
  let bannerItem = null
  if (!isAutoReplaceImg) {
    bannerItem = bannerList[0]
  } else {
    const bannerLen = bannerList.length
    const num = Math.floor((nowTime - createTime) / rotationTime)
    const index = num % bannerLen
    bannerItem = bannerList[index]
  }
  if (!bannerItem) {
    return
  }
  const url = typeof window !== 'undefined' ? location.href : ''
  const urlSubArr = url.split('/')
  const bannerUrl = bannerItem?.bannerUrl
  let path = urlSubArr.slice(0, -1).join('/')
  if (typeof window === 'undefined') {
    path = defaultPathConfigEnv[SENV] || defaultPathConfigEnv.pro
  }
  const jumpUrl = `${path}/${activityId}?spuIds=${bannerItem.spuId}`
  const redirectValue = `https://m.poizon.com/router/web/BrowserPage?loadUrl=${encodeURIComponent(
    jumpUrl
  )}`
  return {
    url: bannerUrl,
    banner: bannerItem,
    activityId,
    spuId: bannerItem.spuId,
    redirect: {
      redirectKey: 108,
      // 手动拼接
      redirectValue,
    },
    /**
     * 埋点素材id
     */
    materialsID: config?.imageInfo?._id,
  }
}
